const getCsrfToken = () => {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.content : '';
};

const shouldAddCsrf = url => !url.includes('/payment/apple-pay/payment-session');

export const post = async (url, body, customHeaders = {}) => {
  const headers = {
    'Content-Type': 'application/json',
    ...customHeaders,
  };
  if (shouldAddCsrf(url)) {
    headers['X-CSRF-Token'] = getCsrfToken();
  }
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
    credentials: 'same-origin',
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const get = async (url, params = {}, customHeaders = {}) => {
  const query = Object.keys(params).length ? '?' + new URLSearchParams(params).toString() : '';
  const headers = {
    ...customHeaders,
  };
  if (shouldAddCsrf(url)) {
    headers['X-CSRF-Token'] = getCsrfToken();
  }
  const response = await fetch(url + query, {
    method: 'GET',
    headers,
    credentials: 'same-origin',
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};
